// @ts-nocheck
import Browsers from '../../_shared/constants/Browsers';

export default class Dropdown {
  constructor(elem) {
    //forEachする要素を個々に書く
    this.menuItems = Array.from(document.querySelectorAll('.js_dropDown_menu'));//htmlcollectionに変換
    this.bodys = elem;
    this.visible = false;//ホバーのフラグ
    // console.log('e');
    this.handleEvent();
  }

  handleEvent() {
    this.bodys.forEach((body, i) => {
      this.trigger = Array.from(body.querySelectorAll('.js_dropDown_trigger'))[0];
      if (Browsers.desktop) {
        body.addEventListener('mouseover', this.toggle.bind(this, true));//生成後のインスタンスを指定
        // body.addEventListener('mouseover', () => {
        //   console.log(this)//メソッドを実行しない場合
        // });
        body.addEventListener('mouseout', this.toggle.bind(this, false));//
      } else {
        // this.boundBodyClicked = this.bodyClicked.bind(this);
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();//aタグのデフォルト動作を無視
          e.stopPropagation();//親要素でイベントが発生しないようにする
          this.toggle(!this.visible, e);
        });
      }
    });
  }
  toggle(visible, e) {
    if (this.visible === visible) return;//trueの場合実行しない
    this.menu = Browsers.desktop ? e.currentTarget.querySelectorAll('.js_dropDown_menu')[0] : e.currentTarget.nextElementSibling;
    this.menu.classList.toggle('is_visible');
    this.visible = visible;//フラグを変更
  }

}
